import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DateRangePicker } from 'react-dates';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import { ReactComponent as UploadFile } from 'Icons/upload-blue.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import Moment from 'moment';
import Sticky from 'Components/Sticky';
import Heading from 'Components/Heading';
import SubHeading from 'Components/SubHeading';
import Dropdown from 'Components/Dropdown';
import ActionLoader from 'Components/ActionLoader';
import ContractRecordDetails from './ContractRecordDetails';
import {
    GET_RFQS_CONTRACT,
    CLEAR_RFQS,
    FETCH_CONTRACTED_RFQS_BETWEEN_DATES,
    GET_GROUPS_AND_TRANSPORTERS,
    GET_TRANSPORTERS_LIST,
    GET_RFQS_CONTRACT_DETAILS,
    DOWNLOAD_EXISTING_CONTRACT_TEMPlATE,
    UPLOAD_EXISTING_CONTRACT_DETAILS,
    UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ,
    POST_CREATE_INDENTS,
    DELETE_UPLOADED_FILE,
    GET_IP_ADDRESS,
    GET_COMPANY_BRANCH_DETAILS,
    GET_RFQ_TRIPS_SUCCESS,
    GET_REGION_NAMES,
    GET_TRIPS_LOG,
    DELETE_CONTRACT_RECORD
} from 'Constants/actionConstants';
import { LOI_ACCEPTED, PROVIDER_VALUE, SEEKER_VALUE, CARGIL, SEEKER, ROQUETTE, EMAMI, STAR_CEMENT, GALAXY_SURFACE } from 'Constants/commonConstants';
import { getCookie, getCompanyType, getUser } from 'Utils/storage';
import Upload from 'Components/Upload';
import { isAdaniWilmar, isBeamS } from 'Utils';
import Checkbox from 'Components/Checkbox/index';
import ActionBlurLoader from 'Components/ActionLoader/LoaderWithBlur';
import { getItemFromLocal, removeItemToLocal, setItemToLocal } from 'Utils/localStorage';
import TripsErrorLogs from './tripsErrorLogsModal';
import { isEmami, isCoromandel } from 'Utils/index';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
class ContractRecords extends Component {
    constructor(props) {
        super(props);
        const searchDetails = getItemFromLocal('contractRecordSearch') || {};
        this.state = {
            isLoading: true,
            startDate: searchDetails.startDate || null,
            endDate: searchDetails.endDate || null,
            searchString: searchDetails.searchString || '',
            openViewDetails: false,
            showPage: false,
            offset: 0,
            limit: 10,
            transporterName: searchDetails.transporterName || '',
            state: searchDetails.state || '',
            transporterId: searchDetails.transporterId || "",
            rfqType: 1
        };
        this.search = this.search.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
    }


    getRFQTimer = null;
    componentDidMount() {
        const { dispatch } = this.props;
        const { transporterId, startDate, endDate, state } = this.state;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
        const branchId = tegUser.branchId;
        const companyType = getCompanyType();
        dispatch({ type: GET_IP_ADDRESS });
        dispatch({ type: GET_COMPANY_BRANCH_DETAILS });
        if(isBeamS()){
            dispatch({ type: GET_REGION_NAMES });
        }
        if(companyType === SEEKER_VALUE) {
            dispatch({
                type: GET_TRANSPORTERS_LIST,
                params: {
                    companyId,
                    branchId
                }
            });
        }
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: 0,
                limit: 10,
                type: LOI_ACCEPTED,
                search: this.state.searchString,
                transporterId,
                branchId: this.state.branchId,
                from: startDate && Moment(startDate).valueOf() || undefined,
                to: endDate && Moment(endDate).valueOf() || undefined,
                region: state,
                seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
            },
            isTransporter: companyType === PROVIDER_VALUE
        });
    }

    handleDateChange(startDate, endDate) {
        const { dispatch } = this.props;
        const companyType = getCompanyType();
        const { transporterId, searchString, branchId } = this.state;
        this.setState({
            startDate: startDate ? Moment(startDate) : null,
            endDate: endDate ? Moment(endDate) : null
        });
        if (startDate && endDate) {
            dispatch({
                type: FETCH_CONTRACTED_RFQS_BETWEEN_DATES,
                params: {
                    offset: 0,
                    limit: 10,
                    type: LOI_ACCEPTED,
                    from: Moment(startDate).valueOf(),
                    to: Moment(endDate).valueOf(),
                    transporterId,
                    search: searchString,
                    branchId: branchId || undefined,
                    seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
                },
                isTransporter: companyType === PROVIDER_VALUE
            })
        }
    }

    goToNextPage = () => {
        this.setState({
            offset: this.state.offset + this.state.limit
        }, () => {
            this.search(this.state.offset);
        });
    }

    goToPrevPage = () => {
        if (this.state.offset != 0) {
            this.setState({
                offset: this.state.offset - this.state.limit
            }, () => {
                this.search(this.state.offset);
            });
        }
    }

    setSearchToLocal = () => {
        const { searchString, transporterId, startDate, endDate, state, branchId, transporterName } = this.state;
        setItemToLocal('contractRecordSearch', {
            searchString,
            transporterId,
            startDate,
            endDate,
            state,
            branchId,
            transporterName
        })
    }

    search = (withOffset) => {
        if (this.getRFQTimer) {
            clearTimeout(this.getRFQTimer)
        }
        const { dispatch } = this.props;
        const { searchString, transporterId, startDate, endDate, branchId } = this.state;
        const companyType = getCompanyType();
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: withOffset > 0 ? withOffset : 0,
                limit: 10,
                type: LOI_ACCEPTED,
                search: this.state.searchString,
                transporterId,
                branchId: branchId || undefined,
                from: startDate && Moment(startDate).valueOf() || undefined,
                to: endDate && Moment(endDate).valueOf() || undefined,
                seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
            },
            isTransporter: getCompanyType() === PROVIDER_VALUE
        });
        this.setSearchToLocal();
    }
    
    searchTransporterwiseRFQ = (e, withOffset) => {
        const transporterId = e.id,
              transporterName = e.name;
        const {dispatch} = this.props;
        const { searchString, startDate, endDate, branchId } = this.state;
        this.setState({ transporterName, transporterId }, this.setSearchToLocal);
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: 0,
                limit: 10,
                type: LOI_ACCEPTED,
                search: searchString,
                transporterId,
                branchId: branchId || undefined,
                from: startDate && Moment(startDate).valueOf() || undefined,
                to: endDate && Moment(endDate).valueOf() || undefined,
            },
        });
    }

    searchBranch = (e) => {
        const branchId = e.branch_id;
        const {dispatch} = this.props;
        const { searchString, startDate, endDate, transporterId } = this.state;
        this.setState({ branchId }, this.setSearchToLocal);
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: 0,
                limit: 10,
                type: LOI_ACCEPTED,
                search: searchString,
                branchId,
                transporterId,
                from: startDate && Moment(startDate).valueOf() || undefined,
                to: endDate && Moment(endDate).valueOf() || undefined,
            },
        });
    }
    searchStatewiseRFQ = (e) => {
        const state = e.region;
        const branchId = e.branch_id;
        const {dispatch} = this.props;
        const { searchString, startDate, endDate, transporterId} = this.state;
        this.setState({ state }, this.setSearchToLocal);
        console.log('state:', state)
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: 0,
                limit: 10,
                type: LOI_ACCEPTED,
                search: searchString,
                branchId,
                transporterId,
                from: startDate && Moment(startDate).valueOf() || undefined,
                to: endDate && Moment(endDate).valueOf() || undefined,
                region:state,
            },
        });
    }


    setGetRFQTimer = () => {
        this.getRFQTimer = setTimeout(() => {
            this.search(this.state.offset)
        }, 10000);
    }
    onChange = (e) => {
        const searchString = e.target.value;
        this.setState({
            ...this.state,
            searchString
        });
    }
    onKeyPress = (e) => {
        if (e.keyCode === 13 || e.which === 13) {
            e.preventDefault();
            this.setState({
                ...this.state,
                searchString: this.state.searchString
            }, () => this.search());
        }
    }

    onClearSearch = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
        const branchId = tegUser.branchId;
        const companyType = getCompanyType();
        this.setState({
            ...this.state,
            searchString: '',
            startDate: null,
            endDate: null,
            transporterName: '',
            transporterId: '',
            branchId: ''
        }, this.setSearchToLocal);
        dispatch({
            type: GET_TRANSPORTERS_LIST,
            params: {
                companyId,
                branchId
            }
        });
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset: 0,
                limit: 10,
                type: LOI_ACCEPTED,
                seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
            },
            isTransporter: getCompanyType() === PROVIDER_VALUE
        });
    }

    toggleViewDetails = () => {
        this.setState({
            ...this.state,
            showViewDetails: !this.state.showViewDetails
        })
    }

    openViewDetails = (rfqId, rfqType, rfq = {}) => {
        const { dispatch, history } = this.props;
        const transporterId = this.state.transporterId || "0";
        dispatch({
            type: GET_RFQ_TRIPS_SUCCESS,
            data: {}
        });
        if (isAdaniWilmar(rfq.companyId) && rfqType === 15) {
            const companyId = rfq.companyId || 0;
            history.push(`/contractRecords/loi-details/${rfqId}/${transporterId}/${rfq.type}/${rfq.rfqStatus}/${companyId}`);
        } else {
            this.setState({
                ...this.state,
                showPage: !this.state.showPage
            });
            history.push(`/contractRecords/details/${rfqId}/${transporterId}/${rfqType}`);
        }
    }

    createIndent = (id) => {
        const { dispatch } = this.props;
        dispatch({
            type: POST_CREATE_INDENTS,
            data: {
                rfq_id: id
            },
            onSuccess: this.getRFQS
        })
    }

    deleteContract = (id) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_CONTRACT_RECORD, 
            data: {
                rfq_id: id
            },
            onSuccess: this.getRFQS
        });
    }

    getBodyForContractRfqs(rfq, index) {
        return (
            <div className="flex flex-between border-bottom-light bg-hover-light pr-10">
                <div className="pl-15 col-2 pt-20 pb-20 pl-15 wt-250">
                    <div className="fs-14 table-text-color fs-14 lh-15p fRegular ">
                        {rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    {rfq.type !== 9  && <>{(rfq.rfqDetails.contractTenureTo && rfq.rfqDetails.contractTenureTo > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : <span className='fs-14 fBold error-color'> Expired </span>}</>}
                </div>
                <div className="header-dark-color col-2 pt-20 pb-20 pl-15 fs-12 wt-200">{rfq.type !== 10 && rfq.serviceTypeName || ''}</div>
                <div className="table-text-color col-1 pt-20 pb-20 pl-15 fs-12 lh-15p">{(rfq.vehicle_list && rfq.vehicle_list.length > 0 && (rfq.vehicle_list || []).join(', ')) || rfq.vehicleTypeName}</div>
                <div className="table-text-color col-1 pl-15 pt-20 fSemibold fs-12 pb-20 lh-15p">{Moment(rfq.rfqDetails.contractTenureFrom).format('Do MMM, YYYY')} -
                    <div>{Moment(rfq.rfqDetails.contractTenureTo).format('Do MMM, YYYY')}</div>
                </div>
                <div className="header-dark-color col-1 pt-20 pb-20 fSemibold fs-12 pl-15">{Moment(rfq.rfqDetails.biddingStart).format('Do MMM, YYYY h:mm:ss a')} -
                    <div>{Moment(rfq.rfqDetails.biddingEnd).format('Do MMM, YYYY h:mm:ss a')}</div>
                </div>
                <div className="wt-250 header-dark-color col-1 fs-12 pt-20 pb-20 pl-15">
                    {new Date(rfq.created).toDateString()}
                    {(rfq.offline_contract && !rfq.created_indents) && <div className="contract-records-floated-on-action">
                    {getCompanyType() === SEEKER_VALUE && 
                        <>
                            <button className="br-20 theme-color border-theme fs-16 fBold pl-10 pr-10 print-trips-button curP ht-30 mt-5 wt-140" onClick={() => this.createIndent(rfq.id)}>Create Indent</button>
                            <button className="br-20 theme-color border-theme fs-16 fBold pl-10 pr-10 print-trips-button curP ht-30 mt-5 wt-140" onClick={() => this.deleteContract(rfq.id)}>Delete Contract</button>
                        </>}
                    </div>}
                    {rfq.trips_error_logs && <div className={"mt-5 theme-color curP fs-14 fBold"} onClick={() => this.onClickTripLogs(rfq.id)}>Trips Error Logs</div>}
                </div>
                {getCompanyType() === SEEKER_VALUE && [...CARGIL, ...EMAMI].includes(getUser().companyId) && <div className="wt-250 header-dark-color col-1 fs-12 pt-20 pb-20 pl-15"><div className='wt-80'>{rfq.rfqDetails.rfqLevelSeekerRemarks}</div></div>}
                <div className="pa  fSemibold fs-14 mr-40  pr-5 theme-color r-0 wt-70">
                    <div className="submit-section flex flex-center flex-middle">
                    {getCompanyType() === SEEKER_VALUE && [...CARGIL, ...EMAMI, ...STAR_CEMENT].includes(getUser().companyId) && <Upload onChange={(file) => this.uploadRFQFile(file, rfq)} fileTypeNonMandatory={CARGIL.includes(getUser().companyId)}>
                                    <UploadFile className="wt-18 mt-15 ht-18"/>
                                </Upload>}
                        <div className="view-details-button mt-15" onClick={() => this.openViewDetails(rfq.id, rfq.type, rfq)}>
                            <button className="br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">View Details</button>
                            {
                                this.state.showPage && <ContractRecordDetails rfq={rfq}/>
                            }
                        </div>
                        <div>
                        </div>
                    </div>
                    {(GALAXY_SURFACE.includes(rfq.companyId)) && (rfq.documents || []).map((val, index) => 
                    <div className="mt-5 wt-150 theme-color">
                            <span className='fBold label-color'>{`T&C: `}</span><a href={val.url} download>{val.name}</a>
                        </div>)}
                    {(rfq.contract_docs || []).length > 0 && <><div className='wt-100 theme-color'>
                        {(rfq.contract_docs || []).map((val, index) => <div className="mt-5">
                            <a href={val.url} download>{index +1}. {val.name}</a>
                            {getCompanyType() === SEEKER_VALUE && <DeleteIcon className="ht-15 wt-15 ml-5 curP" onClick={() => this.onDeleteFile(val.name, rfq)}/>}
                        </div>)}
                    </div></>}
                </div>
            </div>
        );
    }

    onDeleteFile = (fileName, rfq) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_UPLOADED_FILE,
            data: {
                "rfq_id": rfq.id,
                "fileName": fileName,
                "existingRfq": rfq.existingRfq
            },
            onSuccess: this.getRFQS
        });
    }

    downloadtemplate = () => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_EXISTING_CONTRACT_TEMPlATE,
            params: {
                rfqType: this.state.rfqType
            }
        });
    }

    uploadFile = (file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_EXISTING_CONTRACT_DETAILS,
            file,
            params: {
                rfqType: this.state.rfqType,
                ipAddress: localStorage.getItem('IPAddress')
            },
            onSuccess: () => {
                const companyType = getCompanyType();
                dispatch({
                    type: GET_RFQS_CONTRACT,
                    params: {
                        offset: 0,
                        limit: 10,
                        type: LOI_ACCEPTED,
                        rfqType: this.state.rfqType,
                        seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
                    },
                    isTransporter: companyType === PROVIDER_VALUE
                });
            }
        });
    }

    uploadRFQFile = (file, rfq) => {
        const { dispatch } = this.props;
        const params = {
            rfqId: rfq.id,
            existingRfq: rfq.existingRfq
        }
        dispatch({
            type: UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ,
            params,
            file,
            onSuccess: this.getRFQS
        });
    }

    getRFQS = () => {
        const { offset, limit } = this.state;
        const { dispatch } = this.props;
        const companyType = getCompanyType();
        dispatch({
            type: GET_RFQS_CONTRACT,
            params: {
                offset,
                limit,
                type: LOI_ACCEPTED,
                seekerCompanyId: (companyType === PROVIDER_VALUE) ? getItemFromLocal("transporter_seeker_company_id") : undefined
            },
            isTransporter: companyType === PROVIDER_VALUE
        });
    }

    onChangeRFQType = (rfqType) => {
        this.setState({
            rfqType 
        });
    }
    shouldRenderStatesDropdownSection=()=>{
        if(isBeamS()){
            return true;
        }
        return false;
    }
    componentWillUnmount(){
        const { history } = this.props;
        if(!((history.location || {}).pathname.includes('contractRecords/details'))) {
            removeItemToLocal('contractRecordSearch');
        }
    }

    onClickTripLogs = (id) => {
        const { dispatch } = this.props;
        const onSuccess = (data) => {
            this.setState({
                isModalPopupOpen: true,
                tripLogsData: data || {}
            })
        }
        dispatch({
            type: GET_TRIPS_LOG,
            params: {
                rfqId: id
            },
            onSuccess
        })
    }

    handleModalPopupClose = () => {
        this.setState({
            isModalPopupOpen: false,
            tripLogsData: []
        })
    }

    render() {
        const { rfqs, transporters, gettingRFQData, loader, companyBranchDetails,regionNames } = this.props;
        const { gettingRfqs } = this.props.rfqs;
        const { offset, limit, rfqType, tripLogsData, isModalPopupOpen } = this.state;
        const noOfRFQSPerPage = rfqs ? rfqs.length : 0;
        return (
            <Sticky>
                {/* {loader && <ActionLoader fixed={true} />} */}
                {loader && <ActionBlurLoader fixed={true}  />}
                <div className="pl-20 pr-20 pt-20 pb-20">
                    <ScreenTimeTrack
                        screenInfoDetailsItem={
                            screenInfoDetails.CONTRACT_RECORDS_SCREEN
                        }
                    />
                    <Heading type="medium" text="Contract Records" className="mt-10 text-center" />
                    <div className="flex flex-wrap mb-50 pr-10 mt-30 d-block text-center">
                        {getCompanyType() === SEEKER_VALUE && <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <SubHeading text="Transporter" className="mb-10 text-center" />
                            <Dropdown
                                items={transporters}
                                selectedItem={transporters.find(transporter => {return this.state.transporterName === transporter.name})}
                                displayKey="name"
                                name="transporter"
                                label="Select Transporter"
                                searchEnabled={true}
                                searchPlaceholder={'Search Transporter'}
                                onSelect={(e) => this.searchTransporterwiseRFQ(e)}
                                className="text-center wt-250"
                            />
                        </div>}
                        <div className="wt-250 mt-5 ml-5 mb-10 mr-20">
                            <SubHeading text="Branches" className="mb-10 text-center" />
                            <Dropdown
                                items={companyBranchDetails}
                                selectedItem={companyBranchDetails.find(branch => {return this.state.branchId === branch.branch_id})}
                                displayKey="branch_name"
                                name="branchId"
                                label="Select Branch"
                                searchEnabled={true}
                                searchPlaceholder={'Search Branch'}
                                onSelect={(e) => this.searchBranch(e)}
                                className="text-center wt-250"
                            />
                        </div>
                        {this.shouldRenderStatesDropdownSection() && <div className="wt-250 mt-5 ml-5 mb-10 mr-20">
                            <SubHeading text="States" className="mb-10 text-center" />
                            <Dropdown
                                items={regionNames}
                                selectedItem={regionNames.find(states => {return this.state.state === states.region})}
                                displayKey="region"
                                name="states"
                                label="Select State"
                                searchEnabled={true}
                                searchPlaceholder={'Select State'}
                                onSelect={(e) => this.searchStatewiseRFQ(e)}
                                className="text-center wt-250"
                            />
                        </div>}
                        <div className="wt-300 mt-5 ml-5 mb-10 w-inherit text-center">
                            <SubHeading text="Choose Date" className="mb-10" />
                            <DateRangePicker
                                startDate={this.state.startDate}
                                startDateId="startDate"
                                endDate={this.state.endDate}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => { this.handleDateChange(startDate, endDate) }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={() => false}
                            />
                        </div>
                        <div className="mt-30 ml-5 mb-10">
                            <div className="view-details-button" onClick={(e) => this.onClearSearch(e)}>
                                <button className="br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">Clear Filters</button>
                            </div>
                        </div>
                        <div className="wt-250 mt-30 ml-5 mb-10 w-inherit text-center">
                            <span className="clearable">
                                <input
                                    placeholder={"Search RFQ's"}
                                    type="text"
                                    className="mr-30 wt-250 br-20 ht-40 bg-gray search"
                                    value={this.state.searchString || ''}
                                    onChange={e => this.onChange(e)}
                                    onKeyPress={e => this.onKeyPress(e)}
                                />
                                <span className="clearable__clear" onClick={e => this.onClearSearch(e)}>&times;</span>
                            </span>
                        </div>
                        {getCompanyType() === SEEKER_VALUE && (isAdaniWilmar() ? getUser().access_slab_offline : true) &&
                        <>
                            <div className="flex min-wt-200 pl-20 mt-15">
                                <Checkbox label="FTL" checked={rfqType === 1} className="mr-10" onCheck={() => this.onChangeRFQType(1)} />
                                <Checkbox label="Slab Wise" checked={rfqType === 3} className="mr-10" onCheck={() => this.onChangeRFQType(3)} />                                
                                {isBeamS() && <Checkbox label="EXIM - Transporter" checked={rfqType === 12} className="mr-10" onCheck={() => this.onChangeRFQType(12)} />}
                                {(isEmami() || isCoromandel()) && <Checkbox label="Multi Modal" checked={rfqType === 6} className="mr-10" onCheck={() => this.onChangeRFQType(6)} />}
                            </div>
                            <Upload onChange={this.uploadFile} className="mt-25">
                                <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">Upload</button>
                            </Upload>
                            <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10 mt-25" onClick={this.downloadtemplate}>Download</button>
                        </>}
                    </div>
                    <div className="flex flex-right">
                        {
                            noOfRFQSPerPage>0 && <span className="fs-14 mr-5 mt-5 fSemibold caption-color">Showing {this.state.offset + 1} To {this.state.offset + noOfRFQSPerPage}</span>
                        }
                        {
                            offset < limit && <Back className="mr-10" />
                        }
                        {
                            offset >= limit && <Forward className="mr-10 rotate-180deg curP" onClick={() => this.goToPrevPage()} />
                        }
                        {
                            rfqs && rfqs.length >= 10 && <Forward className="mr-40 curP" onClick={() => this.goToNextPage()} />
                        }
                        {
                            rfqs && (rfqs.length == 0 || rfqs.length < 10) && <Back className="mr-10 rotate-180deg" />
                        }
                    </div>                
                    <div className="flex flex-between border-bottom-theme-2 pr-10">
                        <div className="fBold fs-16 col-2 header-dark-color pt-10 pb-10 pl-15 wt-200">RFQ Name</div>
                        <div className="fBold fs-16 col-2 header-dark-color pt-10 pb-10 pl-15">Contract Type</div>
                        <div className="fBold fs-16 col-1 header-dark-color pt-10 pb-10 pl-15">Vehicle Type</div>
                        <div className="fBold fs-16 col-1 header-dark-color wt-100 pt-10 pb-10 pl-15">Contract Validity</div>
                        <div className="fBold fs-16 col-1 wt-250 header-dark-color pt-10 pb-10 pl-15">Bidding Validity</div>
                        <div className="fBold fs-16 col-1 wt-250 header-dark-color pt-10 pb-10 pl-15">Floated On</div>
                        {getCompanyType() === SEEKER_VALUE && [...CARGIL, ...EMAMI].includes(getUser().companyId) && <div className="fBold fs-16 col-1 wt-250 header-dark-color pt-10 pb-10 pl-15">Remarks</div>}
                        {/* <div className="fBold fs-16 wt-70 header-dark-color pt-10 pb-10 pl-15"></div> */}
                    </div>
                    {rfqs && rfqs.length === 0 && gettingRFQData ?
                        <ActionLoader fixed={true}/>
                        :
                        (rfqs || []).map((rfq, index) => {
                            return <div key={index}>
                                {
                                    <React.Fragment>
                                        {
                                            this.getBodyForContractRfqs(rfq, index)
                                        }
                                    </React.Fragment>
                                }
                            </div>
                        })
                    }
                    {   
                        !(rfqs && rfqs.length > 0) &&  !gettingRFQData && 
                            <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No RFQ Has Been Added</div>
                    }
                </div>
                {isModalPopupOpen && <TripsErrorLogs isModalPopupOpen={isModalPopupOpen} data={tripLogsData} handleModalPopupClose={this.handleModalPopupClose}/>}
            </Sticky>
        );
    }
}

const mapStateToProps = ({ constants, rfq, contracting }) => {
    return {
        rfqs: rfq.rfqs.data || [],
        groups: constants.groups || [],
        transporters: constants.transportersList || [],
        regionNames:constants.regionNames||[],
        gettingRFQData: rfq.rfqs.gettingRfqs,
        loader: (contracting.loader || rfq.rfqs.gettingRfqs),
        companyBranchDetails: constants.companyBranchDetails || []
    };
};


export default connect(mapStateToProps)(ContractRecords);
